var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSintMaarten(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 24,
    viewBox: "0 0 30 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#d22f27",
    d: "M0 0h30v24H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#1e50a0",
    d: "M0 12h30v12H0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M14.94 12 0 24V0z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fada10",
    d: "M6.92 9.36c0 .7-.75 1.28-1.66 1.28-.92 0-1.66-.57-1.66-1.28 0-.7.74-1.28 1.66-1.28s1.66.58 1.66 1.28"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#bd725f",
    d: "M3.23 8.82c.36-.35 1.64-.33 2.03-.1-.44-.6.16-.32.63-.32s.6.15.29.18c-.31.04-.57-.01-.49.08.08.1.55.02.97-.08s.9.26.93.32c.03.07-.74-.1-1.01 0-.28.1-.71.08-.68.18.04.1-.45.16-.64.11-.2-.04-.98-.03-.86-.1l.36-.22c.06-.03-.97-.06-1.53-.05"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#dc181e",
    d: "M8.1 9.23s-.73.36-1.46.19c-.81-.2-1.4-.1-1.4.1 0-.2-.6-.3-1.4-.1-.74.17-1.46-.2-1.46-.2s.53.86.21 2.58c-.32 1.75-.23 2.54 1.16 2.6 1.16.04 1.49.39 1.49.39s.32-.35 1.5-.4c1.37-.05 1.47-.84 1.14-2.6-.32-1.7.22-2.56.22-2.56"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#63b0e2",
    d: "M7.57 12.33c-.41-1.41.02-2.57.02-2.57s-.64.19-1.35-.02-1 .15-1 .15-.3-.35-1-.15c-.72.21-1.36.02-1.36.02s.44 1.16.03 2.57.59 1.62 1.27 1.6c.67 0 1.06.38 1.06.38s.38-.39 1.06-.38 1.68-.19 1.27-1.6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M6.86 13.34v-.7H7v-.28h-.17v-.74H7l-1.3-.86v-.35h.2l-.66-.45-.67.45h.2v.35l-1.3.86h.16v.75h-.17v.27h.16v.7h-.2v.35h3.63v-.35zm.12-2.91q0 .4-.12.38c-.07 0-.13-.1-.13-.38s.13-.5.13-.5.12.22.12.5"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M7.34 10.84h-.97c0-.13.21-.24.49-.24.27 0 .48.11.48.24"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#018830",
    d: "M4.02 10.48s-.18.33-.22.52c-.03.2-.14-.12-.14-.12s-.2.2-.24.27c-.05.07-.06-.56 0-.64.06-.09-.15-.06-.22-.1s.15-.27.15-.27-.3-.14-.2-.18.5 0 .64.1c.13.1.45-.07.57-.1s0 .12-.1.2c-.1.1-.05.31-.05.42s-.2-.1-.2-.1"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#b6b6b6",
    d: "M4.56 12.04H6v.4H4.56zm-.69-.34h.44v.57h-.44zm0 .95h.44v.57h-.44zm2.33-.95h.44v.57H6.2zm0 .95h.44v.57H6.2zm-1.28-2.14h.66v.3h-.66z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#fada10",
    d: "m9.14 12.47-.12-.69-.64.21.19.93.14.04s.02.74-.55 1.32-1.57.58-1.57.58-.52.38-1.35.38-1.35-.38-1.35-.38-1 0-1.57-.58c-.57-.57-.56-1.32-.56-1.32l.15-.04.2-.93-.65-.2-.12.68-.23.03s.01 1.35.48 2.06 1.52.93 1.52.93l.04.17c.69.4 2.09.42 2.09.42s1.4-.02 2.09-.42l.03-.17s1.05-.22 1.52-.93.49-2.06.49-2.06z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSintMaarten);
export default __webpack_public_path__ + "static/media/sint-maarten.5943b52b068543b27db9bfdd95483763.svg";
export { ForwardRef as ReactComponent };